module.exports = __webpack_public_path__ + "img/instructor.084b58f7.jpeg";